export default __webpack_public_path__ + "static/media/studio_image.9103bae9.webp";